<template>
  <!-- Team Section Start -->
  <section class="section-padding bg-gray">
    <div class="container">
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">واحد تحصیلات تکمیلی</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row" id="team">
        <div class="col-lg-6 col-md-12 col-xs-12 " v-for="(team , id) in teams" :key="id">
          <!-- Team Item Starts -->
          <div class="team-item wow fadeInRight" data-wow-delay="0.2s">
            <div class="team-img">
              <img class="img-fluid" :src="'/img/team/'+team.img" alt="">
            </div>
            <div class="content ">
              <div class="info-text text-right ">
                <h5 class="rahLine d-inline-block ">{{ team.name }}</h5>
                <p >{{ team.post }}</p>
              </div>
              <p >{{ team.text }}</p>
<!--              <ul class="social-icons">-->
<!--                <li><a :href="team.email"><i class="lni-facebook-filled" aria-hidden="true"></i></a></li>-->
<!--                <li><a :href="team.instagram"><i class="lni-twitter-filled" aria-hidden="true"></i></a></li>-->
<!--                <li><a href="#"><i class="lni-instagram-filled" aria-hidden="true"></i></a></li>-->
<!--              </ul>-->
            </div>
          </div>
          <!-- Team Item Ends -->
        </div>
      </div>
    </div>
  </section>
  <!-- Team Section End -->
</template>

<script>
import {team} from '../Data/teamData';

export default {
  name: "Team",
  data() {
    return {
      teams: team,
    }
  }
}
</script>

<style scoped>

</style>